import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const PickerContainer = styled.div`
  font-size: 1rem;
  height: 10em;
  position: relative;
  background-color: ${ColorPalette.HEX.White};
  overflow: hidden;
  font-family: Poppins;
  display: flex;
  cursor: pointer;
`;

export const PickerGroup = styled.div`
  &.weight-1 {
    flex: 1;
  }
  &.weight-2 {
    flex: 2;
  }
  &.weight-3 {
    flex: 3;
  }
  &.weight-4 {
    flex: 4;
  }
  &.weight-5 {
    flex: 5;
  }
  &.weight-6 {
    flex: 6;
  }
  &.weight-7 {
    flex: 7;
  }
  &.weight-8 {
    flex: 8;
  }
  &.weight-9 {
    flex: 9;
  }
  &.weight-10 {
    flex: 10;
  }
  &.weight-11 {
    flex: 11;
  }
  &.weight-12 {
    flex: 12;
  }
`;

export const PickerList = styled.div`
  height: 6.25em;
  position: relative;
  top: 4em;
  margin: 0 25px;
`;

export const PickerItem = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  text-align: center;
  will-change: transform;
  contain: strict;
  height: 2em;
  line-height: 2;
  font-size: 1em;

  &.text-right {
    text-align: right;
  }
  &.text-left {
    text-align: left;
  }
`;

export const PickerHandler: any = styled.div`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: calc(100% + 2px);
  left: 0;
  right: 0;
  top: -1px;
  bottom: -1px;
  display: flex;
  flex-direction: column;
`;

PickerHandler.Top = styled.div`
  border-bottom: 0.5px solid rgba(171, 169, 162, 0.5);
  background: linear-gradient(to bottom, ${ColorPalette.HEX.White} 2%, rgba(${ColorPalette.RGB.White}, 0.1) 100%);
  transform: translate3d(0, 0, 5.625em);
  flex: 1;
`;

PickerHandler.Middle = styled.div`
  height: 2em;
`;

PickerHandler.Bottom = styled.div`
  border-top: 0.5px solid rgba(171, 169, 162, 0.5);
  background: linear-gradient(to top, ${ColorPalette.HEX.White} 2%, rgba(${ColorPalette.RGB.White}, 0.1) 100%);
  transform: translate3d(0, 0, 5.625em);
  flex: 1;
`;
